import { render, staticRenderFns } from "./GridGeneral.vue?vue&type=template&id=0000ac61&"
import script from "./GridGeneral.vue?vue&type=script&lang=js&"
export * from "./GridGeneral.vue?vue&type=script&lang=js&"
import style0 from "./GridGeneral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports